// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"307bf8ae","360":"c26b9136","549":"238fda86","563":"bd0e5bf3","718":"d609326e","730":"55ea17ea","806":"316ddc6e","841":"02ffd892","964":"7f374961"}[chunkId] + ".chunk.js";
};